<template>
    <nav>
        <ul>
            <li>
                <span role="button"
                      class="grid grid-cols-[auto_1fr_auto] gap-2 justify-between items-center w-full p-2 whitespace-nowrap opacity-100 rounded-md"
                      :class="{
                        'text-leonard-green': active === 'profile',
                        'text-leonard-black hover:text-leonard-green-hover': active !== 'profile'
                      }"
                      @click.prevent="clickMenuItem('profile')"
                >
                    <Profile class="w-4"/>
                    <span class="truncate">Profile</span>
                    <ChevronRight class="w-4"/>
                </span>
            </li>
            <li>
                <span role="button"
                      class="grid grid-cols-[auto_1fr_auto] gap-2 justify-between items-center w-full p-2 whitespace-nowrap opacity-100 rounded-md"
                      :class="{
                        'text-leonard-green': active === 'orderHistory',
                        'text-leonard-black hover:text-leonard-green-hover': active !== 'orderHistory'
                      }"
                      @click.prevent="clickMenuItem('orderHistory')"
                >
                    <OrderHistory class="w-4"/>
                    <span class="truncate">Order History</span>
                    <ChevronRight class="w-4"/>
                </span>
            </li>
            <li>
                <span v-if="isSystemAdmin()"
                      role="button"
                      class="grid grid-cols-[auto_1fr_auto] gap-2 justify-between items-center w-full p-2 whitespace-nowrap opacity-100 rounded-md"
                      :class="{
                        'text-leonard-green': active === 'saleBanner',
                        'text-leonard-black hover:text-leonard-green-hover': active !== 'saleBanner'
                      }"
                      @click.prevent="clickMenuItem('saleBanner')"
                >
                    <Sale class="w-4"/>
                    <span class="truncate">Sale Banner</span>
                    <ChevronRight class="w-4"/>
                </span>
            </li>
        </ul>
    </nav>
</template>

<script>
    import Profile from '../../components/icons/Profile.vue';
    import OrderHistory from "../../components/icons/OrderHistory.vue";
    import Sale from "../../components/icons/Sale.vue";
    import ChevronRight from "../../components/icons/ChevronRight.vue";

    export default {
        components: {ChevronRight, Sale, OrderHistory, Profile},
        props: ['page'],

        data() {
            return {
                active: this.page,
            }
        },

        methods: {
            clickMenuItem(pageName) {
                this.$emit('menuClick', pageName)
                this.active = pageName
            },

            isSystemAdmin() {
                return this.$auth.user().roles.includes('System Admin')
            }
        }
    }
</script>
